<template>
    <div id="menu">
    <div class="menu-top">
        <img class="avatar" src="@/assets/myPic3.webp" width="100px" @click="selectTab(4)"/>
        <div class="name" @click="selectTab(2)">
            <span>
                <b style="font-weight:bold">Bhuvan</b>esh
            </span>
                <div/>
            <span>    
                Shanmuga
            </span>
                
            <span>
                Sundaram
            </span>
        </div>

        <div class="menu-items">
            <ul>
                <!--<li @click="selectTab(1)" :class="{ active: selected_tab == '1' }">
                    <span v-if="selected_tab == '1'" class="spinner">*</span>
                    Blog
                </li>-->
                <li @click="selectTab(2)" :class="{ active: selected_tab == '2' }">
                    Personal Projects
                <span v-if="selected_tab == '2'" class="spinner">></span>
                    
                </li>
                <li @click="selectTab(6)" :class="{ active: selected_tab == '6' }">
                    Art works
                <span v-if="selected_tab == '6'" class="spinner">></span>
                    
                </li>
                <li @click="selectTab(3)" :class="{ active: selected_tab == '3' }">
                    Experience
                <span v-if="selected_tab == '3'" class="spinner">></span>
                    
                </li>
                <li @click="selectTab(4)" :class="{ active: selected_tab == '4' }">
                    About me
                <span v-if="selected_tab == '4'" class="spinner">></span>
                    
                </li>
                <!--<li @click="selectTab(5)" :class="{ active: selected_tab == '5' }">
                    <span v-if="selected_tab == '5'" class="spinner">*</span>
                    Contact
                </li>-->
            </ul>
        </div>
        <br/>
        <div class="icons">
            <a href="https://github.com/BhuvaneshShan" target="_blank" rel="noopener noreferrer">
                <img height="16" width="16" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/github.svg" class="social-icon" />
            </a>
            <a href="https://twitter.com/Bhuvanesh_Shan" target="_blank" rel="noopener noreferrer">
                <img height="16" width="16" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/twitter.svg" class="social-icon" />
            </a>
            <a href="https://www.linkedin.com/in/bhuvaneshshan/" target="_blank" rel="noopener noreferrer">
                <img height="16" width="16" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/linkedin.svg" class="social-icon" />
            </a>
            <a href="https://medium.com/@bhuvanesh_shan" target="_blank" rel="noopener noreferrer">
                <img height="16" width="16" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/medium.svg" class="social-icon" />
            </a>
        </div>
    </div>

    <div class="menu-bottom">
        <div class="theme-switch-wrapper">
            <img height="18" width="18" src="https://unpkg.com/lucide-static@latest/icons/sun.svg" class="theme-icon" :style="{ opacity: theme === 'light' ? 1 : 0.3 }" title="Light Mode" />
            <label class="theme-switch" for="checkbox">
                <input type="checkbox" id="checkbox" :checked="theme === 'dark'" @change="$emit('toggle-theme')" />
                <div class="slider round"></div>
            </label>
            <img height="18" width="18" src="https://unpkg.com/lucide-static@latest/icons/moon.svg" class="theme-icon" :style="{ opacity: theme === 'dark' ? 1 : 0.3 }" title="Dark Mode" />
        </div>
    </div>

    </div>

</template>

<script>
export default {
  name: 'Menu',
  props: ['theme', 'selected_tab'],
  methods:{
      selectTab: function(tabVal){
          this.$emit('tab_selected',tabVal);
      }
  }
}
</script>

<style scoped>
#menu{
    width: 20%;
    min-width: 250px;
    padding-top: 60px;
    padding-bottom: 40px;
    padding-right: 40px;
    padding-left: 40px;
    height: 100vh;
    text-align: right;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: 14px;
    color: var(--text-color);
    border-right: 1px solid var(--hover-bg);
    position: sticky;
    top: 0;
}

.menu-top {
    flex: 1;
}

.theme-switch-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    padding-top: 20px;
}

.theme-icon {
    filter: var(--icon-filter);
    transition: opacity 0.3s;
}

/* Explicit Toggle Switch */
.theme-switch {
  display: inline-block;
  height: 20px;
  position: relative;
  width: 40px;
}

.theme-switch input {
  display:none;
}

.slider {
  background-color: #ccc;
  bottom: 0;
  cursor: pointer;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transition: .4s;
}

.slider:before {
  background-color: #fff;
  bottom: 4px;
  content: "";
  height: 12px;
  left: 4px;
  position: absolute;
  transition: .4s;
  width: 12px;
}

input:checked + .slider {
  background-color: #444;
}

input:checked + .slider:before {
  transform: translateX(20px);
}

.slider.round {
  border-radius: 20px;
}

.slider.round:before {
  border-radius: 50%;
}

.menu-items{
    margin-top:40px
}

@media screen and (max-width: 600px){
    #menu {
        position: relative;
        padding: 40px 20px;
        height: auto;
        text-align: center;
        width: 100%;
        border-right: none;
        border-bottom: 1px solid var(--hover-bg);
    }
    .theme-switch-wrapper {
        justify-content: center;
        margin-top: 20px;
    }
    .avatar{
        margin-top: 10px;
        margin-bottom: 5px;
    }
    .menu-items{
        margin-top: 20px;
    }
}

.name{
    font-size: 28px;
    font-weight: lighter;
    cursor: pointer;
    color: var(--heading-color);
}

li{
    margin-top:10px;  
    cursor: pointer;  
    font-size: 16px;
    color: var(--text-color);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
}

@media screen and (max-width: 600px) {
    li {
        justify-content: center;
    }
}

li:hover {
    color: var(--link-color);
}

.spinner {
    display: inline-block;
    font-family: monospace;
    font-size: 20px;
    color: var(--text-color);
}

@keyframes rotate {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

.avatar{
    border-radius: 50%; 
    margin-bottom: 20px;
    border: 3px solid var(--hover-bg);
    cursor: pointer;
    transform: rotate(-5deg);
}

.social-icon {
    margin-left: 10px;
    filter: var(--icon-filter);
    transition: opacity 0.3s;
}

.social-icon:hover {
    opacity: 0.7;
}

.icons{
    margin-top: 20px;
}
</style>